import { Label } from 'components/atoms';
import ValidationError from './ValidationError';
import Warning from './Warning';
import clsx from 'clsx';
export interface Props {
  'data-testid': string;
  className?: string;
  label?: string;
  validationError?: string;
  helperText?: string;
  helperTextClassName?: string;
  warning?: string;
  size?: 'lg';
}

const FieldLabel = ({
  className,
  ...props
}: React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement>) => (
  <label
    className={clsx('block text-base leading-5 w-full md:w-fit whitespace-nowrap', className)}
    {...props}
  />
);

const Field: React.FC<Props> = ({
  children,
  label,
  validationError,
  helperText,
  helperTextClassName,
  warning,
  size,
  ...props
}) => {
  const errorTestId = 'validation-error-for-' + props['data-testid'];
  const helperTestId = 'helper-text-for-' + props['data-testid'];
  const warningTestId = 'warning-for-' + props['data-testid'];
  const Container = size === 'lg' ? FieldLabel : label ? Label : 'div';

  return (
    <Container {...props}>
      {label && <span className="block mb-0.5">{label}</span>}
      {children}
      {helperText && (
        <span
          className={clsx('block text-xs leading-4 mt-0.5', helperTextClassName || 'text-grey-2')}
          data-testid={helperTestId}
        >
          {helperText}
        </span>
      )}
      <ValidationError className="mt-0.5" data-testid={errorTestId}>
        {validationError}
      </ValidationError>
      <Warning className="mt-0.5" data-testid={warningTestId}>
        {warning}
      </Warning>
    </Container>
  );
};

export default Field;
